// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reference hover/active and icon opacity – .nav-btn:hover, .nav-btn.active, .nav-icon */
.sidebar-nav-btn img {
  width: 20px;
  height: 20px;
  opacity: 0.3;
  transition: opacity 0.2s ease;
}

.sidebar-nav-btn:hover {
  background: rgba(202, 202, 202, 0.05);
}

.sidebar-nav-btn:hover img {
  opacity: 1;
}

.sidebar-nav-btn-active img {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.nav.css"],"names":[],"mappings":"AAAA,yFAAyF;AACzF;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Reference hover/active and icon opacity – .nav-btn:hover, .nav-btn.active, .nav-icon */\n.sidebar-nav-btn img {\n  width: 20px;\n  height: 20px;\n  opacity: 0.3;\n  transition: opacity 0.2s ease;\n}\n\n.sidebar-nav-btn:hover {\n  background: rgba(202, 202, 202, 0.05);\n}\n\n.sidebar-nav-btn:hover img {\n  opacity: 1;\n}\n\n.sidebar-nav-btn-active img {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
